import authSlice from './auth-slice';
import translateSlice from './translate-slice';
import studyYearsSlice from './studyYears-slice';
import coursesSlice from './course-slice';
import topicsSlice from './topic-slice';
import disciplinesSlice from './discipline-slice';
import permissionsSlice from './permissions-slice';
import { initTexts } from './translate-actions';
import { fetchYears } from './studyYears-actions';
import { configureStore } from '@reduxjs/toolkit';
import applicationSlice from './application-slice';
import errorHandlingSlice from '../components/lms-shared/store/error-handling-slice'
import lessonSlice from './lesson-slice';
import filteredAssessments from './filteredAssessments-slice';
import generalSlice from './general-slice';
import signalRMessagesSlice from '../components/lms-shared/store/signalRMessages-slice';

const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        translate: translateSlice.reducer,
        studyYears: studyYearsSlice.reducer,
        courses: coursesSlice.reducer,
        signalRMessages:signalRMessagesSlice.reducer,
        topics: topicsSlice.reducer,
        disciplines: disciplinesSlice.reducer,
        permissions: permissionsSlice.reducer,
        application: applicationSlice.reducer,
        errorHandling: errorHandlingSlice.reducer,
        filteredAssessments: filteredAssessments.reducer ,
        lessons: lessonSlice.reducer,
        general: generalSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    })
});

export default store;